import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import instructChar from '../images/character1.png';
import typingSound from '../sounds/escribir.mp3';


const SlideComponent = ({ actual, first, second, setCanGoNext }) => {
    const { t, i18n } = useTranslation();
    const displayOption = (item) => i18n.language === 'en' && item.option_en ? item.option_en : item.option;
    const [selectedButtonGroup1, setSelectedButtonGroup1] = useState(null);
    const [selectedButtonGroup2, setSelectedButtonGroup2] = useState(null);
    const [title, setTitle] = useState(null);
    const [displayedText, setDisplayedText] = useState('');
    const [typingActive, setTypingActive] = useState(false);

    const overlayRef = useRef(null);
    const audioRef = useRef(null);

    useEffect(() => {
        const savedButtonGroup1 = localStorage.getItem('selected0');
        const savedButtonGroup2 = localStorage.getItem('selected1');
        const savedTest = JSON.parse(localStorage.getItem('currentTest') || '[]');
        setTitle(savedTest.title);
        if (savedButtonGroup1) setSelectedButtonGroup1(savedButtonGroup1);
        if (savedButtonGroup2) setSelectedButtonGroup2(savedButtonGroup2);
    }, []);

    useEffect(() => {
        if (setCanGoNext) setCanGoNext(selectedButtonGroup1 !== null && selectedButtonGroup2 !== null);
    }, [selectedButtonGroup1, selectedButtonGroup2, setCanGoNext]);

    useEffect(() => {
        const overlay = overlayRef.current;
        if (!overlay) return;
        const observer = new MutationObserver(() => {
            if (overlay.style.display !== 'none') {
                setDisplayedText('');
                setTypingActive(true);
            }
        });
        observer.observe(overlay, { attributes: true, attributeFilter: ['style'] });
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!typingActive) return;
        const fullText = t('visual.bubble');
        if (displayedText.length >= fullText.length) {
            setTypingActive(false);
            if (audioRef.current) { audioRef.current.pause(); audioRef.current.currentTime = 0; }
            return;
        }
        if (audioRef.current && audioRef.current.paused) {
            audioRef.current.volume = 0.3;
            audioRef.current.loop = true;
            audioRef.current.play().catch(() => {});
        }
        const timeout = setTimeout(() => {
            setDisplayedText(fullText.slice(0, displayedText.length + 1));
        }, 28);
        return () => clearTimeout(timeout);
    }, [typingActive, displayedText, t]);

    const handleButtonClickGroup1 = (buttonId) => {
        setSelectedButtonGroup1(buttonId);
        localStorage.setItem('selected0', buttonId);
    };

    const handleButtonClickGroup2 = (buttonId) => {
        setSelectedButtonGroup2(buttonId);
        localStorage.setItem('selected1', buttonId);
    };

    const handleQuitInstructions = () => {
        const instructionsDiv = overlayRef.current;
        if (instructionsDiv) instructionsDiv.style.display = 'none';
        setTypingActive(false);
        if (audioRef.current) { audioRef.current.pause(); audioRef.current.currentTime = 0; }
    };

    return (
        <div className="slide-container">
            <audio ref={audioRef} src={typingSound} />
            <div className="overlay" id="instructions-div" ref={overlayRef}>
                <div className="vi-instruct-scene">
                    <img src={instructChar} alt="" className="vi-instruct-char" />
                    <div className="vi-instruct-bubble-wrap">
                        <div className="vi-bubble-row">
                            <svg className="vi-tail-svg" width="28" height="20" viewBox="0 0 28 20">
                                <polygon points="28,0 28,20 0,10" fill="#fff" stroke="#111" strokeWidth="3" strokeLinejoin="round"/>
                            </svg>
                            <div className="vi-bubble-shell">
                                <div className="vi-instruct-bubble">
                                    <p className="vi-instruct-text">{displayedText}<span className="vi-instruct-cursor">|</span></p>
                                </div>
                                <button className="vi-instruct-close" onClick={handleQuitInstructions} aria-label={t('common.close')}>×</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ts-phase-icon" role="img" aria-label={t('stats.visual_phase')}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                </svg>
                <span className="ts-phase-icon-tip">{t('stats.visual_phase')}</span>
            </div>
            <div className="actual-wine">{title}</div>
            <div className="vi-phase">
                <div className="vi-title"><span>{t('visual.title')}</span></div>
                <div className="vi-group" role="group">
                    <div className="vi-section">
                        <div className="vi-section-label">{t('visual.intensity')}</div>
                        <div className="vi-btn-grid">
                            {first.question.map((item, index) => {
                                const isSelected = selectedButtonGroup1 === item.option;
                                return (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`vi-btn${isSelected ? ' vi-selected' : ''}`}
                                        onClick={() => handleButtonClickGroup1(item.option)}
                                    >
                                        {displayOption(item)}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <div className="vi-divider" />

                    <div className="vi-section">
                        <div className="vi-section-label">{t('visual.color')}</div>
                        <div className="vi-btn-grid">
                            {second.question.map((item, index) => {
                                const isSelected = selectedButtonGroup2 === item.option;
                                return (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`vi-btn${isSelected ? ' vi-selected' : ''}`}
                                        onClick={() => handleButtonClickGroup2(item.option)}
                                    >
                                        {displayOption(item)}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SlideComponent;
